import React from 'react';
import {useHeader} from '../../_core/HeaderProvider';
import {AnimateLoading} from '../../../_partials/controls';
import styles from './styles.module.scss';
import {QuickUserToggler} from '../extras/QuiclUserToggler';

export function Header() {
  const header = useHeader();
  return (
    <div className={styles.headerContainer}>
      <AnimateLoading/>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{header.title}</div>
        <div className={styles.userToggler}><QuickUserToggler/></div>
      </div>
    </div>
  );
}
